/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyMinIntegratedCounselingIntervalMinutesResponseTypename =
  "PutPharmacyMinIntegratedCounselingIntervalMinutesResponse" as const;

/**
 *
 * @export
 * @interface PutPharmacyMinIntegratedCounselingIntervalMinutesResponse
 */
export interface PutPharmacyMinIntegratedCounselingIntervalMinutesResponse {
  /**
   *
   * @type {number}
   * @memberof PutPharmacyMinIntegratedCounselingIntervalMinutesResponse
   */
  minIntegratedCounselingIntervalMinutes?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyMinIntegratedCounselingIntervalMinutesResponse
   */
  readonly __typename?: string;
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesResponseFromJSON(
  json: any
): PutPharmacyMinIntegratedCounselingIntervalMinutesResponse {
  return PutPharmacyMinIntegratedCounselingIntervalMinutesResponseFromJSONTyped(json, false);
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyMinIntegratedCounselingIntervalMinutesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyMinIntegratedCounselingIntervalMinutesResponseTypename,

    minIntegratedCounselingIntervalMinutes: !exists(json, "min_integrated_counseling_interval_minutes")
      ? undefined
      : json["min_integrated_counseling_interval_minutes"],
  };
}

export function PutPharmacyMinIntegratedCounselingIntervalMinutesResponseToJSON(
  object?: PutPharmacyMinIntegratedCounselingIntervalMinutesResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    min_integrated_counseling_interval_minutes: value.minIntegratedCounselingIntervalMinutes,
  };
}
